import { render, staticRenderFns } from "./ProductTracingCard.vue?vue&type=template&id=4f492a0e&scoped=true&"
import script from "./ProductTracingCard.vue?vue&type=script&lang=ts&"
export * from "./ProductTracingCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f492a0e",
  null
  
)

export default component.exports